import { InjectionToken, Signal } from '@angular/core';
import { dsEnums, webEnums } from '@vectronic/openApi-customer';

export interface DeviceTypeEntry {
  id?: string;
  customerName?: string;
  comType?: webEnums.ComType;
  deviceClassWithOwnIdPool?: dsEnums.DeviceClassWithOwnIdPool;
}

export abstract class DeviceTypeResolver {
  abstract readonly deviceTypes: Signal<DeviceTypeEntry[]>;
}

export const DEVICE_TYPE_RESOLVER = new InjectionToken<DeviceTypeResolver>('DEVICE_TYPE_RESOLVER');
